import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TEXT = "At Tea DM, we're passionate about crafting the perfect cup for every mood. Whether you're craving a classic milk tea, a bold coffee blend, or a fruity smoothie, we have something special waiting for you.";
const HIGHLIGHT = new Set(["perfect", "cup", "every", "mood."]);

const Word = ({ word, progress, range }) => {
  const opacity = useTransform(progress, range, [0.28, 1]);
  return (
    <motion.span style={{ opacity }} className={`mr-[0.25em] inline-block ${HIGHLIGHT.has(word) ? "font-serif-x font-normal text-[#ff2e63]" : ""}`}>
      {word}
    </motion.span>
  );
};

export const Statement = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 85%", "end 45%"] });
  const words = TEXT.split(" ");
  return (
    <section ref={ref} data-testid="statement-section" className="bg-[#fff5e8] py-24 sm:py-36">
      <div className="wrap grid gap-10 lg:grid-cols-12">
        <p className="eyebrow text-[#1a0a10]/70 lg:col-span-3">What makes us special</p>
        <h2 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tight text-[#1a0a10] sm:text-5xl lg:col-span-9 lg:text-[4.2rem]">
          {words.map((w, i) => (
            <Word key={i} word={w} progress={scrollYProgress} range={[i / words.length, Math.min(1, (i + 3) / words.length)]} />
          ))}
        </h2>
      </div>
    </section>
  );
};
